var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailOtp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    rx: 60,
    fill: "#003485"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.1667 47.083L55.2595 61.8479C56.9675 63.0435 57.8215 63.6413 58.7504 63.8729C59.571 64.0774 60.4292 64.0774 61.2497 63.8729C62.1787 63.6413 63.0327 63.0435 64.7407 61.8479L85.8334 47.083M46.5667 80.6663H73.4334C77.7738 80.6663 79.944 80.6663 81.6018 79.8216C83.0601 79.0786 84.2457 77.893 84.9887 76.4348C85.8334 74.777 85.8334 72.6067 85.8334 68.2663V51.733C85.8334 47.3926 85.8334 45.2224 84.9887 43.5646C84.2457 42.1063 83.0601 40.9207 81.6018 40.1777C79.944 39.333 77.7738 39.333 73.4334 39.333H46.5667C42.2263 39.333 40.0561 39.333 38.3983 40.1777C36.9401 40.9207 35.7545 42.1063 35.0114 43.5646C34.1667 45.2224 34.1667 47.3926 34.1667 51.733V68.2663C34.1667 72.6067 34.1667 74.777 35.0114 76.4348C35.7545 77.893 36.9401 79.0786 38.3983 79.8216C40.0561 80.6663 42.2263 80.6663 46.5667 80.6663Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailOtp);
export default __webpack_public_path__ + "static/media/email-otp.4a879d93e202b70f4cb09493419fc911.svg";
export { ForwardRef as ReactComponent };